import PropTypes from 'prop-types';
import { useTheme } from '../../ThemeContext';
import './styles.css';

const brandSizeMap = { sm: 32, md: 48, lg: 64, xl: 80 };

const brandAssets = {
  color: '/nara-v42-gradient.svg',
  light: '/nara-v42-mono-light.svg',
  dark: '/nara-v42-mono-dark.svg',
};

const NaraBrand = ({
  symbolOnly = false,
  horizontal = false,
  size = 'md',
  className = '',
  theme = 'auto',
}) => {
  useTheme();
  const brandTheme = theme === 'auto' ? 'color' : theme;
  const assetHeight = typeof size === 'number' ? size : brandSizeMap[size];
  const assetWidth = Math.round(assetHeight * 1.16);

  return (
    <div
      className={`nf-brand nf-brand--${brandTheme} ${horizontal ? 'nf-brand--horizontal' : ''} ${symbolOnly ? 'nf-brand--symbol-only' : ''} ${className}`.trim()}
      style={{
        '--nf-brand-symbol-size': `${assetHeight}px`,
        '--nf-brand-symbol-width': `${assetWidth}px`,
      }}
      aria-label={symbolOnly ? 'Nara' : undefined}
    >
      <img
        className="nf-brand__symbol"
        src={brandAssets[brandTheme]}
        width={assetWidth}
        height={assetHeight}
        alt={symbolOnly ? 'Nara' : ''}
      />
      {!symbolOnly && <span className="nf-brand__name">Nara</span>}
    </div>
  );
};

NaraBrand.propTypes = {
  symbolOnly: PropTypes.bool,
  horizontal: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.oneOf(['sm', 'md', 'lg', 'xl']), PropTypes.number]),
  className: PropTypes.string,
  theme: PropTypes.oneOf(['auto', 'light', 'dark']),
};

export default NaraBrand;
